// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__rtYi+","lg":"Panel_lg__vghw9","row":"Panel_row__p1hFG","column":"Panel_column__MS5Tb"};